import { axiosInstance } from '../axios';
import type { ApiResponse } from '../../types/common';
import type {
  InstituteSubscriptionSettingsDto,
  UpdateInstituteSubscriptionSettingsRequest,
  SubscriptionPlanAdminDto,
  CreateSubscriptionPlanRequest,
  UpdateSubscriptionPlanRequest,
} from '../../types/institute';

export const subscriptionsApi = {
  // Institute subscription settings
  getInstituteSubscriptionSettings: (instituteId: number) =>
    axiosInstance.get<ApiResponse<InstituteSubscriptionSettingsDto>>(
      `/v1/product-admin/institutes/${instituteId}/subscription-settings`
    ),

  updateInstituteSubscriptionSettings: (
    instituteId: number,
    request: UpdateInstituteSubscriptionSettingsRequest
  ) =>
    axiosInstance.put<ApiResponse<boolean>>(
      `/v1/product-admin/institutes/${instituteId}/subscription-settings`,
      request
    ),

  // Global plan CRUD
  getAllPlans: () =>
    axiosInstance.get<ApiResponse<SubscriptionPlanAdminDto[]>>('/v1/product-admin/subscription-plans'),

  createPlan: (request: CreateSubscriptionPlanRequest) =>
    axiosInstance.post<ApiResponse<SubscriptionPlanAdminDto>>('/v1/product-admin/subscription-plans', request),

  updatePlan: (planId: number, request: UpdateSubscriptionPlanRequest) =>
    axiosInstance.put<ApiResponse<SubscriptionPlanAdminDto>>(
      `/v1/product-admin/subscription-plans/${planId}`,
      request
    ),

  deletePlan: (planId: number) =>
    axiosInstance.delete<ApiResponse<boolean>>(`/v1/product-admin/subscription-plans/${planId}`),
};
